import { RefObject, SyntheticEvent, useLayoutEffect } from 'react'

import { IconSearch } from '@avantstay/backoffice-vectors'

import { ICON_SIZE } from '../constants'
import { useClassNames } from '../utils/useClassNames'

export interface SearchChange {
  keyword: string
  event: SyntheticEvent
}

interface SearchBarProps {
  value: string
  placeholder: string
  inputRef: RefObject<HTMLInputElement>
  keepFocused: boolean
  onChange: (change: SearchChange) => void
}

export const SearchBar = ({
  value,
  placeholder,
  inputRef,
  keepFocused,
  onChange,
}: SearchBarProps) => {
  const { prefix, withClassPrefix } = useClassNames('picker-search-bar')

  useLayoutEffect(() => {
    if (keepFocused) {
      inputRef.current?.focus()
    }
  })

  return (
    <div role="searchbox" className={withClassPrefix()}>
      <input
        className={prefix('input')}
        value={value}
        onChange={event => onChange({ keyword: event.target.value, event })}
        placeholder={placeholder}
        ref={inputRef}
      />
      <IconSearch className={prefix('search-icon')} width={ICON_SIZE} height={ICON_SIZE} />
    </div>
  )
}
